const toggleSurvey = (payload) => {
  return {
    type: "openSruvey",
    payload,
  };
};

export default toggleSurvey;
